import jsPDF from 'jspdf';

/**
 * Generate a text-based PDF from markdown content as a fallback
 * when html2canvas fails
 */
export const generateTextPDF = (title: string, content: string): void => {
  try {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;
    const maxWidth = pageWidth - (margin * 2);
    
    let yPosition = margin;
    
    // Add title
    pdf.setFontSize(20);
    pdf.setFont('helvetica', 'bold');
    const titleLines = pdf.splitTextToSize(title, maxWidth);
    pdf.text(titleLines, margin, yPosition);
    yPosition += titleLines.length * 10 + 10;
    
    // Process content - remove markdown formatting for plain text
    const plainText = content
      .replace(/^#{1,6}\s+/gm, '') // Remove headers
      .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold
      .replace(/\*(.*?)\*/g, '$1') // Remove italic
      .replace(/^[-*+]\s+/gm, '• ') // Convert list items
      .replace(/^\d+\.\s+/gm, '') // Remove numbered lists
      .replace(/^---+$/gm, '') // Remove horizontal rules
      .replace(/\n{3,}/g, '\n\n') // Normalize line breaks
      .trim();
    
    // Add content
    pdf.setFontSize(11);
    pdf.setFont('helvetica', 'normal');
    
    const lines = plainText.split('\n');
    
    for (const line of lines) {
      if (line.trim() === '') {
        yPosition += 5;
        continue;
      }
      
      const wrappedLines = pdf.splitTextToSize(line, maxWidth);
      
      // Check if we need a new page
      if (yPosition + (wrappedLines.length * 5) > pageHeight - margin) {
        pdf.addPage();
        yPosition = margin;
      }
      
      pdf.text(wrappedLines, margin, yPosition);
      yPosition += wrappedLines.length * 5 + 2;
    }
    
    // Add footer with generation date
    const totalPages = pdf.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.text(
        `Generated on ${new Date().toLocaleDateString()} - Page ${i} of ${totalPages}`,
        margin,
        pageHeight - 10
      );
    }
    
    pdf.save(`${title.replace(/\s+/g, '_')}.pdf`);
  } catch (error) {
    console.error('Error generating text PDF:', error);
    throw new Error('Failed to generate PDF');
  }
}; 